import axios from '../axios/redditlikeApi'

const login = form => axios.post('/login', form)
const socialLogin = form => axios.post('/social-login', form)
const health = () => axios.get('/login')
const getToken = () => localStorage.getItem('jwtToken')
const setToken = jwtToken => localStorage.setItem('jwtToken', jwtToken)
const deleteToken = () => localStorage.removeItem('jwtToken')
const getUser = () => localStorage.getItem('user')
const setUser = user => localStorage.setItem('user', user)
const deleteUser = () => localStorage.removeItem('user')

export default {
  login,
  socialLogin,
  health,
  getToken,
  setToken,
  deleteToken,
  getUser,
  setUser,
  deleteUser
}
